<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="AB_NAME" label="公司"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="20">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-view" size="small" @click="openProject(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 新增选择公司模态框 -->
    <el-dialog title="请选择项目点" center :visible.sync="addFormVisible" width="600px">
      <el-form :model="addForm" ref="addForm" style="margin-top: 0">
        <el-form-item label="项目点名称：" :label-width="formLabelWidth" prop="leader">
          <label slot="label">项目点名称：</label>
          <el-select filterable v-model="addForm.project" placeholder="请选择" style="width:100%" @change="setDis">
            <el-option v-for="item in projects" :key="item.value" :label="item.NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('addForm')">取 消</el-button>
        <el-button size="small" @click="submitAdd('addForm')" v-if="ProName === ''" disabled>确 定</el-button>
        <el-button size="small" @click="submitAdd('addForm')" v-else>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { haveTCFun, haveXMDFun } from 'api/shopPrice';

export default {
  data() {
    return {
      addFormVisible: false,
      formLabelWidth: '100px',
      tableData: [],
      currentPage: 0,
      totalCount: 0,
      pageSize: 10,
      addForm: {},
      projects: [],
      ProName: '',
    };
  },
  methods: {
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTitle();
    },
    setDis() {
      this.ProName = this.addForm.project;
    },
    // -----------------------确认按钮
    submitAdd(formName) {
      this.$router.push({ name: 'soldPriceDetail' });
      sessionStorage.setItem('projectId', this.addForm.project);
    },
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
    },
    openProject(row) {
      this.addFormVisible = true;
      this.queryProject(row);
    },
    // -------------------------------初始化数据
    queryTitle() {
      haveTCFun()
        .then((result) => {
          this.tableData = result.length > 0 ? result[0].company : [];
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    queryProject(row) {
      const params = {
        TC_ID: row.ID,
      };
      haveXMDFun(params)
        .then((result) => {
          this.projects = result.length > 0 ? result : [];
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTitle();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/costCenter/soldPrice.vue